import React from 'react'
import ChartSwitch from './chart-switch'
import withSend from 'microcosm/addons/with-send'
import PatchLink from 'lib/components/patch-link'
import Select from 'lib/components/select'
import Icon from 'lib/components/icon'

// Specific values required by analytics
function getChartPanelName(name) {
  switch (name) {
    case 'valuationBoxPlot':
      return 'valuation chart'
    case 'implementationBarChart':
      return 'implementation chart'
    case 'correlationChart':
      return 'correlation chart'
    case 'timeSeriesChart':
      return 'time series chart'
    default:
      return null
  }
}

class ChartSelectorExpanded extends React.PureComponent {
  onChange = event => {
    this.props.send('patchQuery', { expandedSelection: event.target.value })
  }

  getOptions() {
    return this.props.options.map(function({ value, text }) {
      // Expanded options are matched upon text only
      return { text, value: text }
    })
  }

  renderSelect() {
    const { name, selected, disableOptions, hideOptions } = this.props

    if (hideOptions) {
      return null
    }

    return (
      <Select
        labelFor={name}
        labelVisible={false}
        label="Chart Data"
        options={this.getOptions()}
        disabled={disableOptions}
        onChange={this.onChange}
        selected={selected.text}
      />
    )
  }

  render() {
    const { query, name, selected, ...dataProps } = this.props
    const trackChartName = selected ? selected.text.toLowerCase() : null

    const closeQuery = { expanded: undefined, expandedSelection: undefined }

    return (
      <div className="charts__main__expanded track-as-chart-panel" data-track={getChartPanelName(name)}>
        <PatchLink query={closeQuery} className="charts__main__expanded__close">
          <span className="type-subtitle">Close</span>
          <Icon type="close" />
        </PatchLink>

        <div className="chart-container track-as-chart-name" data-track={trackChartName}>
          <div className="chart-container__menu -wide split-nav">
            <div className="split-nav__main">
              <div className="chart-selector">{this.renderSelect()}</div>
            </div>
          </div>

          <div className="chart-container__chart">
            <ChartSwitch
              query={query}
              chart={selected}
              expanded
              {...dataProps}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default withSend(ChartSelectorExpanded)



// WEBPACK FOOTER //
// ./src/components/chart-selector-expanded.js